export const NOTE_RECLAMATION = {
    SET_JWT: 'SET_JWT',
    RESET_JWT: 'RESET_JWT',
};
